export default __webpack_public_path__ + "locales/hy-AM/InfoPanel.json?hash=892dd6ffcffb131b241e243c7f3273bb";